export default "<div class=\"tool-before\"></div>\n<ng-content></ng-content>\n<div class=\"tool-after\"></div>\n"